import React from 'react';
import AnalyseStyled from './AnalyseStyled';
import Detail from './analyle_detail/Detail';
import { Box, Button } from '@material-ui/core';
import { Close } from '@material-ui/icons';
import { history } from 'umi';
import DataAnalyle from './analyle_echarts/DataAnalyle';
const Analyse = (props) => {
  const { code, name, dateBegin, dateEnd } = props.location.query;
  const handleCancel = () => {
    history.push('/marketing/account_activity_manage');
  };
  return (
    <AnalyseStyled>
      <Detail code={code} name={name} dateBegin={dateBegin} dateEnd={dateEnd} />
      <DataAnalyle code={code} />
      <Box className="footer">
        <Button
          variant="contained"
          color="secondary"
          className="finish"
          onClick={handleCancel}
          startIcon={<Close sx={{ width: '16px', height: '16px' }} />}
        >
          退出
        </Button>
      </Box>
    </AnalyseStyled>
  );
};
export default Analyse;
